import './style.css'
import Experience from './Experience/Experience'

// THREEJS Setup
const experience = new Experience(document.querySelector('canvas.webgl'));
